export default __webpack_public_path__ + "static/media/HL_Physics.f62549b1.svg";